import { convertToLocalTime } from "../Admin/util";

export class ContractTableData {
  count: number;
  next: any;
  previous: any;
  results: ContractTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.next = obj?.next;
    this.previous = obj?.previous;
    this.results = obj?.results?.map(
      (item: any) => new ContractTableEntity(item)
    );
  }
}
export class ContractTableEntity {
  [key: string]: any;
  file: string;
  id: string;
  vendorName: string;
  contractId: string;
  simbaId: string;
  documentId: string;
  contractType: string;
  serviceType: string;
  startDate: string;
  endDate: string;
  mtc: string;
  title: string;

  constructor(obj: any) {
    this.file = obj?.name;
    this.id = obj?.id;
    this.vendorName = obj?.doc_meta?.vendor_name;
    this.contractId = obj?.doc_meta?.contract_id;
    this.simbaId = obj?.doc_meta?.simba_id;
    this.documentId = obj?.doc_meta?.document_id;
    this.contractType = obj?.doc_meta?.contract_type;
    this.serviceType = obj?.doc_meta?.service_type;
    this.startDate = obj?.doc_meta?.start_date;
    this.endDate = obj?.doc_meta?.end_date;
    this.mtc =
      obj.doc_meta.maximum_total_cost !== "N/A"
        ? `$ ${obj.doc_meta.maximum_total_cost}`
        : obj.doc_meta.maximum_total_cost;
    this.title = obj?.doc_meta?.title;
  }
}

export class BulkClauseTableEntity {
  [key: string]: any;
  vendorName: string;
  engagementName: string;
  contractId: string;
  simbaId: string;
  documentId: string;
  vertical: string;
  serviceType: string;
  id: string;
  status: string;
  startDate: string;
  endDate: string;
  mtc: string;
  displayName: string;
  title: string;
  vendorWithType: {
    vendor: string;
    docType: string;
  };

  constructor(obj: any) {
    this.id = obj?.id;
    this.displayName = obj?.display_name;
    this.status = obj?.status;
    this.vendorName = obj?.clause_meta?.vendor_name || obj?.display_name;
    this.title = obj?.clause_meta?.title;
    this.engagementName =
      obj?.clause_meta?.engagement_name || obj?.clause_meta?.contract_type;
    this.contractId = obj?.clause_meta?.contract_id;
    this.simbaId = obj?.clause_meta?.simba_id;
    this.documentId = obj?.clause_meta?.document_id;
    this.vertical = obj?.clause_meta?.vertical;
    this.serviceType = obj?.clause_meta?.service_type;
    this.startDate = obj?.clause_meta?.start_date || "NA";
    this.endDate = obj?.clause_meta?.end_date || "NA";
    this.mtc = obj?.clause_meta?.maximum_total_cost
      ? ` $${obj?.clause_meta?.maximum_total_cost}`
      : "NA";
    this.vendorWithType = {
      vendor: this.vendorName,
      docType: this.engagementName,
    };
  }
}

export class BulkClauseTableData {
  count: number;
  results: BulkClauseTableEntity[];
  next: any;
  previous: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map(
      (res: any) => new BulkClauseTableEntity(res)
    );
    this.next = obj?.next;
    this.previous = obj?.previous;
  }
}

export class BulkSummaryTableEntity {
  [key: string]: any;
  vendorName: string;
  engagementName: string;
  earnBack: {};
  volumeDiscount: {};
  investments: {};
  prodImprove: {};
  benchRecommendation: {};
  overtime: {};
  contractId: string;
  simbaId: string;
  documentId: string;
  title: string;
  id: string;
  vendorWithType: {
    vendor: string;
    docType: string;
  };
  clauseCheckDetails: {};

  constructor(obj: any) {
    this.vendorName = obj?.metadata?.vendor_name;
    this.id = obj?.id;
    this.title = obj?.metadata?.title;
    this.clauseCheckDetails = obj?.clause_check_details?.reduce(
      (acc: any, el: any) => {
        return { ...acc, [el?.category]: el };
      },
      {}
    );
    this.engagementName =
      obj?.metadata?.engagement_name || obj?.metadata?.contract_type;
    this.contractId = obj?.metadata?.contract_id;
    this.simbaId = obj?.metadata?.simba_id;
    this.documentId = obj?.metadata?.document_id;
    this.earnBack = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "SLA Penalties/Earn Back"
    )[0];
    this.volumeDiscount = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Volume Discounts"
    )[0];
    this.investments = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Non-EPP Investments"
    )[0];
    this.prodImprove = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Productivity Improvements"
    )[0];
    this.benchRecommendation = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Committed Buffer/Bench Pool"
    )[0];
    this.overtime = obj?.clause_check_details?.filter(
      (item: any) => item?.category === "Overtime/On-call & Holiday Bill Rates"
    )[0];
    this.vendorWithType = {
      vendor: this.vendorName,
      docType: this.engagementName,
    };
  }
}

export class BulkSummaryTableData {
  count: number;
  results: BulkSummaryTableEntity[];
  next: any;
  previous: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results = obj?.results?.map(
      (res: any) => new BulkSummaryTableEntity(res)
    );
    this.next = obj?.next;
    this.previous = obj?.previous;
  }
}

class UserManagementTableEntity {
  name: string;
  userId: string;
  roles: any;
  action: any;

  constructor(obj: any) {
    this.name = obj?.name;
    this.userId = obj?.userId;
    this.roles = obj?.roles;
    this.action = obj?.action;
  }
}
export class UserManagementTable {
  count: number;
  results: UserManagementTableEntity[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count;
    this.results = obj?.results?.map(
      (res: any) => new UserManagementTableEntity(res)
    );
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class VerticalTableData {
  count: number;
  results: VerticalTableEntity[];
  previous: any;
  next: any;

  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.results =
      obj?.results?.map((item: any) => new VerticalTableEntity(item)) || [];
    this.previous = obj?.previous;
    this.next = obj?.next;
  }
}

export class VerticalTableEntity {
  name: string;
  drive_link: string;
  is_enabled: boolean;
  id: string;
  service_account_email: string;
  is_auto_sync: boolean | null;
  sync_interval_hours: number | null;
  move_expired_files: boolean | null;
  expired_destination_drive_link: string | null;
  last_sync_completed_at: string | null;
  next_sync_at: string | null;
  sync_status: string; 


  constructor(obj: any) {
    this.name = obj?.name || "";
    this.drive_link = obj?.drive_link || "N/A";
    this.is_enabled = obj?.is_enabled || false;
    this.id = obj?.id;
    this.service_account_email = obj?.service_account_email;
    this.is_auto_sync = obj?.is_auto_sync;
    this.sync_interval_hours = obj?.sync_interval_hours;
    this.move_expired_files = obj?.move_expired_files;
    this.expired_destination_drive_link = obj?.expired_destination_drive_link;
    const lastSyncRaw = obj?.last_sync_completed_at;
    const nextSyncRaw = obj?.next_sync_at;

    this.last_sync_completed_at = lastSyncRaw
      ? convertToLocalTime(lastSyncRaw)
      : "N/A";
    this.next_sync_at = nextSyncRaw
      ? convertToLocalTime(nextSyncRaw)
      : "N/A";
    this.sync_status = obj.sync_status ;
  }
}
